// Some native/web transports do not settle when aborted after suspension.
// Release the caller independently, while consuming any late resolution or
// rejection. The operation itself still receives the same signal and must
// check ownership before applying side effects.
export function abortable(promise, signal) {
  return new Promise((resolve, reject) => {
    const cancel = () => reject(new Error('AUTH_TIMEOUT'));
    Promise.resolve(promise).then(resolve, reject)
      .finally(() => signal.removeEventListener('abort', cancel));
    if (signal.aborted) { cancel(); return; }
    signal.addEventListener('abort', cancel, { once: true });
  });
}
